<style>
    .page-item {
        cursor: pointer;
    }
    h4 {
        text-transform: capitalize;
    }
</style>

<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Pembelian</h1>
            <div class="section-header-breadcumb button">
                <a href="javascript:" @click.prevent="goTo('/pembelian/pemesanan-pembelian')" class="btn btn-icon icon-left btn-primary"><i class="far fa-edit"></i> Pemesanan Pembelian</a>
                <a v-if="url[0] == 'faktur' && $parent.isprice" @click="showModalPayment()" style="margin-left:5px;" class="btn btn-icon icon-left btn-warning"><i class="fa fa-dollar"></i> Buat Pembayaran</a>
            </div>
          </div>
        <div class="section-body">
            <h2 v-if="url[0] == 'pembayaran'" class="section-title">Pembelian Belum Dibayar : Rp. {{ currencyFormat(sisa_tagihan) }}</h2>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                    <div class="card-header">
                        <h4>Daftar {{ url[0] }} Pembelian</h4>
                        <div class="card-header-form">
                            <div class="input-group">
                            <input type="text" class="form-control" v-model="filter" @keyup.enter="setFilter()" placeholder="Search">
                            <div class="input-group-btn">
                                <button @click="setFilter()" class="btn btn-primary"><i class="fas fa-search"></i></button>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="table-responsive">
                        <table class="table table-bordered table-md">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th v-if="url[0] == 'pembayaran' || url[0] == 'selesai'">Tanggal Invoice</th>
                                    <th v-else>Tanggal</th>
                                    <th v-if="url[0] == 'pemesanan' || url[0] == 'packing'">Nomor</th>
                                    <th v-if="url[0] == 'pembayaran' || url[0] == 'selesai'">Nomor Invoice</th>
                                    <th v-if="url[0] == 'pengiriman' || url[0] == 'faktur'">No. Srt Jalan</th>
                                    <th>Supplier</th>
                                    <th v-if="url[0] == 'pengiriman' || url[0] == 'faktur'">Tgl Pengiriman</th>
                                    <th v-else-if="url[0] == 'pembayaran' || url[0] == 'selesai' ">Tgl Jatuh Tempo</th>
                                    <!-- <th v-if="url[0] == 'selesai'">Tanggal Dibayar</th> -->
                                    <!-- <th v-if="url[0] != 'selesai'">Jumlah DP</th> -->
                                    <th v-if="url[0] == 'selesai' || url[0] == 'pembayaran'">Jumlah Total USD | IDR</th>
                                    <th v-if="url[0] == 'selesai' || url[0] == 'pembayaran'">Dibayar USD | IDR</th>
                                    <th v-if="url[0] == 'pembayaran' || url[0] == 'selesai'">Status Pembayaran</th>
                                </tr>
                            </thead>
                            
                            <tbody>
                                <tr style="cursor:pointer;" v-for="list in transaksiList" v-bind:key="list.main.id_transaksi" @click="goDetail(list.main.id_transaksi,list.main.tipe_transaksi)">
                                    <td>{{ list.no }}</td>
                                    <td v-if="url[0] == 'pembayaran' || url[0] == 'selesai'"> {{ list.main.tanggal_invoice_pembayaran | moment("DD MMMM YYYY") }} </td>
                                    <td v-else-if="url[0] == 'pemesanan' || url[0] == 'packing'">{{ list.main.tanggal_transaksi | moment("DD MMMM YYYY") }}</td>
                                    <td v-else> {{ list.main.tanggal_packing | moment("DD MMMM YYYY") }} </td>
                                    <td v-if="url[0] == 'pemesanan' || url[0] == 'packing'" >{{ list.main.nomor_transaksi }}</td>
                                    <td v-if="url[0] == 'pembayaran' || url[0] == 'selesai'">{{ list.main.nomor_invoice }}</td>
                                    <td v-if="url[0] == 'pengiriman' || url[0] == 'faktur'">{{ list.main.nomor_pengiriman }}</td>
                                    <td>{{ list.main.display_name }}</td>
                                    <td v-if="url[0] == 'pengiriman' || url[0] == 'faktur'">{{ list.main.tanggal_pengiriman | moment("DD MMMM YYYY") }}</td>
                                    <td v-else-if="url[0] == 'pembayaran' || url[0] == 'selesai' ">{{ list.main.tanggal_jatuh_tempo_pembayaran | moment("DD MMMM YYYY") }}</td>
                                    <!-- <td v-if="url[0] == 'selesai'"> {{ list.main.tanggal_pembayaran | moment("DD MMMM YYYY") }} </td> -->
                                    <!-- <td v-if="url[0] != 'selesai'">Rp. {{ currencyFormat(list.main.dibayar) }}</td> -->
                                    <td v-if="url[0] == 'selesai' || url[0] == 'pembayaran'">$. {{ currencyFormat(list.main.grand_total) }} | Rp. {{ currencyFormat(list.main.grand_total_idr) }}</td>
                                    <td v-if="url[0] == 'selesai' || url[0] == 'pembayaran'">$. {{ currencyFormat(list.main.dibayar) }} | Rp. {{ currencyFormat(list.main.dibayar_idr) }}</td>
                                    <td v-if="url[0] == 'pembayaran' || url[0] == 'selesai'"> <span v-html="statusCallback(list.main.status_lunas)"></span> </td>
                                </tr>
                            </tbody>
                            
                        </table>
                        </div>
                    </div>
                    <div class="card-footer text-right">
                        <nav class="d-inline-block">
                        <ul class="pagination mb-0">
                            <li class="page-item disabled">
                                <a class="page-link" href="#" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                            </li>
                            <li v-for="pages in pagination" v-bind:key="pages" class="page-item" :class="{ active: pages == page}">
                                <span class="page-link" @click="tableTo(pages)">{{ pages }}</span>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="#"><i class="fas fa-chevron-right"></i></a>
                            </li>
                        </ul>
                        </nav>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
        <modal name="make-payment">
            <div class="card">
                <div class="card-header">
                    <h4>Pilih Jenis Pembayaran</h4>
                </div>
                <div class="card-body text-center">
                    <div class="form-group" style="text-align:left">
                        <label>Jenis Pembayaran</label>
                        <select id="pembayaran" v-model="jenis_pembayaran" class="form-control">
                            <!-- <option value="invoice" >Berdasarkan Invoice </option> -->
                            <option value="surat-jalan" >Berdasarkan Surat Jalan </option>
                        </select>
                    </div>
                </div>
                <div class="card-footer" style="text-align:right">
                    <a href="javascript:" @click.prevent="goTo('/pembelian/buat-pembayaran/'+jenis_pembayaran)" class="btn btn-warning">Buat Pembayaran</a>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'

Vue.use(VModal)

export default {
    data() {
        return {
            jenis_pembayaran: '',
            transaksiList : [],
            perPage: 10,
            page: 1,
            search: '',
            maxPagination: 5,
            first: 1,
            last: '',
            totalRow: '',
            pagination: [],
            url : '',
            filter : '',
            sisa_tagihan: 0,
        }
    },
    mounted() {
        this.url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        this.url = this.url.split('-');    
        this.init();
    },
    methods: {
        init: function() {
            this.$root.is_loading = !this.$root.is_loading;
            this.$http.get("Transaksi/getPembelianList/"+this.url[0]+"?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter).then(result => {
			    if(result.data.code == '00') {
                    alert('failed get produk')
                }
                else {
                    this.transaksiList = result.data.detail.data;
                    this.sisa_tagihan = result.data.detail.tagihan;
                    this.totalRow = result.data.detail.totalRow;
                    this.last = Math.ceil(this.totalRow / this.perPage)
                    this.pagination = this.getPaging();
                }
                this.$root.is_loading = !this.$root.is_loading;
			}, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            });
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        getPaging: function() {
            var i;
            var paging = []
            if(this.page > this.first+2){
                this.first = this.page-3
            }else if(this.page == this.first && this.first != 1){
                this.first = this.page-3
                if(this.first < 1){
                    this.first = 1
                }
            }
            for(i = this.first;i < 6+this.first && i <= this.last; i++){
                paging.push(i)
            }
            return paging;
        },
        tableTo: function(page){
            this.page = page
            this.init();
        },
        goDetail: function(id_transaksi,type){
            var u = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
            this.$router.push({ path : u+'-detail/'+id_transaksi+'/'+type })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        setFilter: function() {
            this.init();
        },
        statusBayarCallback: function(val) {
            if(val == 1){
                return '<span style="color:green;">Dibayar</span>'
            }else{
                return '<span style="color:red;">Belum Dibayar</span>'
            }
        },
        statusCallback: function(val) {
            if(val == 1){
                return '<span style="color:green;">Dibayar</span>'
            }else{
                return '<span style="color:red;">Belum Dibayar / Belum Lunas</span>'
            }
        },
        showModalPayment: function() {
            this.$modal.show('make-payment');
        },
        hideModalPayment: function() {
            this.$modal.hide('make-payment');
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pembelian/PembelianList.vue